import {mutation, query} from "@/graphql/client";
import {gql} from "@urql/vue";
import {Booking, DirectDemand, DirectDemandLogEntry} from "@/graphql/generated/graphql";
import {bookingDetailFragment} from "@/helper/booking";
import {jobsiteDetailsFragment} from "@/helper/jobsite";
import {graphql} from "@/graphql/generated";

export async function fetchDirectDemand(directDemandId: number): Promise<DirectDemand|undefined>
{
    const result = await query(
        graphql(`
            
            query GetDirectDemand(
            $directDemandId: Int!,
        ) {
            directDemand(
                directDemandId: $directDemandId,
            ) {
                id
                demand {
                    date
                    begin
                    until
                    jobsite {
                        ...JobsiteDetailsFragment
                    }
                    shiftType
                }
                date
            }
        }`),
        {
            directDemandId: directDemandId
        }
    );
    const success = result?.data

    if (!success) {
        return undefined
    }

    return result.data?.directDemand;
}

export async function fetchDirectDemandHistory(directDemandId: number): Promise<DirectDemandLogEntry[]|undefined>
{
    const result = await query(
        graphql(`
            
            query GetDirectDemandHistory(
            $directDemandId: Int!,
        ) {
            directDemandHistory(
                directDemandId: $directDemandId,
            ) {
                timestamp
                auditorTransactionStatus
                date
                begin
                until
                shiftType
                jobsite {
                    ...JobsiteDetailsFragment
                }
            }
        }`),
        {
            directDemandId: directDemandId
        }
    );

    return result.data?.directDemandHistory;
}




export async function acceptDirectDemand(directDemandId: number ): Promise<Booking> {

    const MUTATION = graphql(`
        
        mutation AcceptDirectDemand(
            $directDemandId: Int!,
        ) {
            acceptDirectDemand(
                directDemandId: $directDemandId,
            )
            {
                ...BookingDetailFragment
            }
        }`)

    const result = await mutation(
        MUTATION, {
            directDemandId: directDemandId,
        }
    )

    const success = result?.data

    if (!success) {
        throw new Error("error while accepting direct demand")
    }

    return success.acceptDirectDemand
}

export async function declineDirectDemand(directDemandId: number ) {

    const MUTATION = graphql(`
        mutation DeclineDirectDemand(
            $directDemandId: Int!,
        ) {
            declineDirectDemand(
                directDemandId: $directDemandId,
            )
        }`)

    const result = await mutation(
        MUTATION, {
            directDemandId: directDemandId,
        }
    )

    const success = result?.data

    if (!success) {
        throw new Error("error while decining direct demand")
    }

    return success
}
